// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__T0xou","half":"Icon_half__qFXUj"};